import { useEffect, useState } from 'react';

import { listBillingOrigins } from '../../../../services/finance/billingApi';
import { listBankAccounts } from '../../../../services/finance/bankAccountsApi';

// ---------------------------------------------------------------------------
// Catálogos dos filtros — carregam UMA vez, em paralelo, e falham em silêncio.
//
// São opções de filtro, não conteúdo: se a chamada cair, o grupo de chips fica
// vazio, mas o dashboard carrega normalmente. Um toast aqui só assustaria o
// operador sobre algo que não afeta os números na tela.
//
// `bank-accounts` exige `finance:bank_account:read`, permissão DIFERENTE da que
// abre o dashboard (`finance:dashboard:read`) — quem não a tem simplesmente não
// vê o grupo de CNPJ (que já fica oculto com uma conta só).
// ---------------------------------------------------------------------------

export default function useDashboardCatalogs({ canReadBankAccounts }) {
   const [origins, setOrigins] = useState([]);
   const [bankAccounts, setBankAccounts] = useState([]);

   useEffect(() => {
      let alive = true;

      listBillingOrigins()
         .then((rows) => {
            if (alive) setOrigins(rows);
         })
         .catch(() => {
            /* filtro sem opções não bloqueia a leitura do painel */
         });

      return () => {
         alive = false;
      };
   }, []);

   useEffect(() => {
      if (!canReadBankAccounts) return undefined;
      let alive = true;

      // Sem filtro de status: conta inativa segue tendo histórico de cobranças
      // e precisa ser recortável no painel.
      listBankAccounts({})
         .then((rows) => {
            if (alive) setBankAccounts(rows);
         })
         .catch(() => {
            /* idem */
         });

      return () => {
         alive = false;
      };
   }, [canReadBankAccounts]);

   return { origins, bankAccounts };
}
